import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";
import Reservations from "views/admin/reservations";
import CheckIn from "views/admin/checkin";
import CheckOut from "views/admin/checkout";
import Categories from "views/admin/Categories";
import Rooms from "views/admin/rooms";
import Staff from "views/admin/staff";
import Items from "views/admin/items";
import GuestBilling from "views/admin/billing";
import Users from "views/admin/users";
import Transactions from "views/admin/transactions";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdHome,
  MdBarChart,
  MdPerson, 
  MdLock,
} from "react-icons/md";

const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />, 
    allowedRoles: ["admin", "staff"],
  },
  {
    name: "Reservations",
    layout: "/admin",
    path: "reservations",
    icon: <MdBarChart className="h-6 w-6" />,
    component: <Reservations />,
    allowedRoles: ["admin", "staff"],
    // requiredPermissions: ["reservations.order"],
  },
  {
    name: "Check In",
    layout: "/admin",
    path: "check-in",
    icon: <MdPerson className="h-6 w-6" />,
    component: <CheckIn />,
    allowedRoles: ["admin", "staff"],
    requiredPermissions: ["reservations.order"],
  },
  {
    name: "Check Out",
    layout: "/admin",
    path: "check-out/:hash",
    icon: <MdPerson className="h-6 w-6" />,
    component: <CheckOut />,
    allowedRoles: ["admin", "staff"],
    requiredPermissions: ["reservations.order"],
    hiddenInSidebar: true,
  },
  {
    name: "Categories",
    layout: "/admin",
    path: "categories",
    icon: <MdBarChart className="h-6 w-6" />,
    component: <Categories />,
    allowedRoles: ["admin", "staff"],
  },
  {
    name: "Rooms",
    layout: "/admin",
    path: "rooms",
    icon: <MdBarChart className="h-6 w-6" />,
    component: <Rooms />,
    allowedRoles: ["admin", "staff"],
  },
  {
    name: "Items",
    layout: "/admin",
    path: "items",
    icon: <MdBarChart className="h-6 w-6" />,
    component: <Items />,
    allowedRoles: ["admin", "staff"],
  },
  {
    name: "Staff Management",
    subText: "Manage staff accounts and roles",
    layout: "/admin",
    path: "staff",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Staff />,
    allowedRoles: ["admin", "staff"],
  },
  {
    name: "Transactions",
    layout: "/admin",
    path: "transactions",
    icon: <MdBarChart className="h-6 w-6" />,
    component: <Transactions />,
    allowedRoles: ["admin"],
    hiddenInSidebar: true,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
  {
    name: "Billing",
    layout: "/admin",
    path: "billing",
    icon: <MdBarChart className="h-6 w-6" />,
    component: <GuestBilling />,
    allowedRoles: ["admin", "staff"],
    hiddenInSidebar: true,
  }

];
export default routes;
